import { resetPinCode as apiResetPin } from "@blacknut/javascript-sdk/dist/api/Family/Pin/resetPinCode";
import { Dispatch } from "redux";
import { ProfilesAction, ProfilesActionTypes } from "./Profiles";

export const dismissResetPinError = () => {
  return (dispatch: Dispatch<any>) => {
    dispatch({ type: ProfilesActionTypes.RESET_PIN_ERROR });
  };
};
export const resetPin = () => {
  return (dispatch: Dispatch<ProfilesAction>) => {
    return new Promise<void>((resolve, reject) => {
      dispatch({ type: ProfilesActionTypes.RESET_PIN_REQUEST });
      apiResetPin().subscribe({
        next: (res) => {
          dispatch({ type: ProfilesActionTypes.RESET_PIN_SUCCESS, profile: res });
          resolve();
        },
        error: (error) => {
          dispatch({ type: ProfilesActionTypes.RESET_PIN_ERROR, error });
          reject(error);
        },
      });
    });
  };
};
